<template>
  <div v-if="vital_sign.care_has_feeding_care.length > 0">
    <div
      style="page-break-inside: avoid !important"
      class="text-center"
      v-for="item in vital_sign.care_has_feeding_care"
      :key="item.id"
    >
      <p
        :class="[
          'm-0 text-thirteen upper-text',
          item.response == 'BOA ACEITAÇÃO' && 'color-green',
          item.response == 'ACEITOU PARCIAL' && 'color-orange',
          item.response == 'NÃO ACEITOU' && 'color-red',
        ]"
      >
        {{ item.name }} - {{ item.response }}
      </p>
      <p class="mb-1 worksansr text-twelve upper-text">
        CADASTRADO POR: {{ item.user_name }}
      </p>
      <hr />
    </div>
  </div>
</template>

<script>
import { formatTime } from "../../../../../lib/format";

export default {
  name: "Diurese",
  props: {
    vital_sign: Object,
  },
  methods: { formatTime },
};
</script>